import createCache from "@emotion/cache"

export function createEmotionCache() {
  const nonce =
    document.querySelector('meta[name="csp-nonce"]')?.getAttribute("content") ||
    undefined

  return createCache({
    key: "app",
    nonce: nonce,
  })
}
